import React, { useEffect, useState } from 'react';
import { ApiEvent, ApiEventStatusEnum, eventsApi, sanctionsApi } from '../apis';
import store from '../store/store';
import { showFeedback } from '../feedback/feedbackReducer';
import { SalvButton, Size } from '@salvapp/ui-components';

const ScreeningCheckButton = () => {
  const [processing, setProcessing] = useState(false);
  const [event, setEvent] = useState<ApiEvent | null>(null);

  useEffect(() => {
    const checkEventStatus = async () => {
      if (event) {
        const updatedEvent = await eventsApi.findEventById({
          eventId: event.id,
        });
        if (updatedEvent.status === ApiEventStatusEnum.PROCESSED) {
          setProcessing(false);
        }
      }
    };

    let timerId: any;
    if (processing) {
      timerId = setInterval(checkEventStatus, 1000);
    } else {
      timerId && clearInterval(timerId);
    }

    return () => timerId && clearInterval(timerId);
  }, [processing, event]);

  const triggerOrganisationCheck = async () => {
    setProcessing(true);
    try {
      const event = await sanctionsApi.checkOrganisation();
      setEvent(event);
    } catch (e: any) {
      store.dispatch(
        showFeedback({
          message: e.status === 422 ? 'Organisation check is already in progress' : 'Something went wrong',
          success: false,
        })
      );
      setProcessing(false);
    }
  };

  return (
    <SalvButton
      label='Check again now'
      size={Size.SMALL}
      onClick={() => triggerOrganisationCheck()}
      disabled={processing}
    />
  );
};

export default ScreeningCheckButton;
